import React, { useState, useEffect, useContext, useRef } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { apiFetch } from '../utils/apiFetch';

interface UserProps 
{
  user: 
  {
    username: string;
    password: string | null;
    password_repeat: string | null;
  };

  onSave: (userData: 
  {
    username: string;
    password: string;
    password_repeat: string;
  }) => void;

  onCancel: () => void;
}

const User: React.FC<UserProps> = ({ user, onSave, onCancel }) => 
{
  const { token } = useContext(AuthContext);
  const [username, setUsername] = useState(user.username);
  const [password, setPassword] = useState('');
  const [password_repeat, setPasswordRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const modalRef = useRef<HTMLDivElement>(null); // Ref para el contenedor del modal

  //-----------------------------------------------------------

  useEffect(() => {
    setUsername(user.username);
    setPassword('');
    setPasswordRepeat('');
  }, []);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    // Función para manejar clics fuera del componente
    const handleClickOutside = (event: MouseEvent) => 
    {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onCancel();
      }
    };

    // Función para manejar presiones de teclas
    const handleEscPress = (event: KeyboardEvent) => 
    {
      if (event.key === 'Escape') 
      {
        onCancel();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscPress);

    return () => 
    {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscPress);
    };
  }, [onCancel]);  

  //-----------------------------------------------------------

  const handleSubmit = async (e: React.FormEvent) => 
  {
    e.preventDefault();

    if (password != password_repeat) {
      setError('Las contraseñas no coinciden');
      return;
    }
    
    try 
    {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);
      formData.append('password_repeat', password_repeat);

      const response = await apiFetch('web/update_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'},
        body: formData.toString(),
      });

      if (response.ok) 
      {
        onSave({ 
          username, 
          password: password, 
          password_repeat: password_repeat});
      } 
      else 
      {
        const errorData = await response.json();
        setError(errorData.message || 'Error al guardar la contraseña.');
      }
    } 
    catch (error) 
    {
      setError('Error de red. Por favor, intente nuevamente.');
    }
  };

  //-----------------------------------------------------------
  
  return (
    <div className="user-container" ref={modalRef}>
      <h2>Cambiar contraseña</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            id="password"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            title="Contraseña"
            placeholder="Contraseña"
            required
          />
        </div>
        <div className="form-group">
          <input
            id="password_repeat"
            type="password"
            onChange={(e) => setPasswordRepeat(e.target.value)}
            title="Repetir contraseña"
            placeholder="Repetir contraseña"
            required
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <div className="form-actions">
          <div className="form-actions-right">
            <button type="button" onClick={onCancel}>Cancelar</button>
            <button type="submit" className='save-button'>Guardar</button>  
          </div>  
        </div>
      </form>
      
    </div>
  );
};

export default User;
